import type { Bbox } from '@/types/domain';

/**
 * Half-width, in degrees, of the box a lone listing is grown into. Roughly 5km
 * north-south — small enough that ListingMap's FIT_MAX_ZOOM still decides the
 * final zoom, large enough that view.fit has a real area to work with.
 */
const MIN_HALF_SPAN_DEG = 0.05;

/**
 * A box `view.fit` can actually use.
 *
 * One matching listing gives a zero-area extent, and fitting a box with no
 * width asks OpenLayers for an infinite zoom — it either ignores the call or
 * jumps to maximum zoom, both of which read as "the button is broken". Only a
 * degenerate axis is grown, and it is grown around its own centre, so a genuine
 * Ankara-to-Trabzon box comes back untouched.
 */
export function paddedExtent(bbox: Bbox): Bbox {
  const [minLng, minLat, maxLng, maxLat] = bbox;
  const padLng = Math.max(0, MIN_HALF_SPAN_DEG - (maxLng - minLng) / 2);
  const padLat = Math.max(0, MIN_HALF_SPAN_DEG - (maxLat - minLat) / 2);
  return [minLng - padLng, minLat - padLat, maxLng + padLng, maxLat + padLat];
}
